export default [
    //信贷管理
    {
        path: '/credit',
        component: () => import( '@/views/loud/credit/credit.vue'),
    },
    // 返利列表
    {
        path: '/rebate',
        component: () => import( '@/views/loud/credit/rebate.vue'),
    },
    // 返利详情
    {
        path: '/rebateDetail',
        component: () => import( '@/views/loud/credit/rebateDetail.vue'),
    },
    // 客户明细账数据
    {
        path: '/customerLedger',
        component: () => import( '@/views/loud/credit/customerLedger.vue'),
        meta: {
            title: '信贷明细',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 客户明细账数据
    {
        path: '/customerOrder',
        component: () => import( '@/views/loud/credit/customerOrder.vue'),
    },
    // 客户详情
    {
        path: '/customerDetails',
        component: () => import( '@/views/loud/credit/customerDetails.vue' ),
        meta: {
            title: '客户详情',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 主管详情
    {
        path: '/supervisorDetails',
        component: () => import( '@/views/loud/credit/supervisorDetails.vue' ),
        meta: {
            title: '资金详情',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 主管详情
    {
        path: '/supervisorDetails-hyj',
        component: () => import( '@/views/loud/credit/supervisorDetails-hyj.vue' )
    },
	// 信贷审批
	{
	    path: '/creditApprove',
	    component: () => import( '@/views/loud/credit/creditApprove.vue' )
	},
	// 信贷审批详情
	{
	    path: '/creditApproveDetail',
	    component: () => import( '@/views/loud/credit/creditApproveDetail.vue' )
	},
    //	订单赊销列表-内销
    {
        path: '/creditchargesales',
        component: () => import( '@/views/loud/credit/creditchargesales.vue'),
        meta: {
            title: '订单赊销',
            isTabsPage: true,
            keepAlive: true
        }
    },
	//	订单赊销列表-外销
	{
	    path: '/creditchargesalesWx',
	    component: () => import( '@/views/loud/credit/creditchargesalesWx.vue'),
        meta: {
            title: '订单赊销',
            isTabsPage: true,
            keepAlive: true
        }
	},
	//	订单赊销列表-上海
	{
	    path: '/creditchargesalesSh',
	    component: () => import( '@/views/loud/credit/creditchargesalesSh.vue'),
        meta: {
            title: '订单赊销',
            isTabsPage: true,
            keepAlive: true
        }
	},
    //	sap退税列表
    {
        path: '/tuishuizhanshi',
        component: () => import( '@/views/loud/credit/tuishuizhanshi.vue'),
        meta: {
            title: '财务退税凭证',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/tuishuisuccesshistory',
        component: () => import( '@/views/loud/credit/tuishuisuccesshistory.vue'),
        meta: {
            title: '成功退税历史记录',
            isTabsPage: true,
            keepAlive: true
        }
    },
	//	内销信贷比对
	{
	    path: '/creditCompare',
	    component: () => import( '@/views/loud/credit/creditCompare.vue'),
        meta: {
            title: '信贷比对（内销）',
            isTabsPage: true,
            keepAlive: true
        }
	},
	//	外销信贷比对
	{
	    path: '/creditCompareWx',
	    component: () => import( '@/views/loud/credit/creditCompareWx.vue'),
        meta: {
            title: '信贷比对（外销）',
            isTabsPage: true,
            keepAlive: true
        }
	},
	//	上海信贷比对
	{
	    path: '/creditCompareSh',
	    component: () => import( '@/views/loud/credit/creditCompareSh.vue'),
        meta: {
            title: '信贷比对（上海）',
            isTabsPage: true,
            keepAlive: true
        }
	},
    //	外销应收报表
    {
        path: '/creditchargesalesWxWkp',
        component: () => import( '@/views/loud/credit/creditchargesalesWxWkp.vue'),
        meta: {
            title: '外销应收',
            isTabsPage: true,
            keepAlive: true
        }
    },
    //	外销应收逾期报表
    {
        path: '/creditWxYqReport',
        component: () => import( '@/views/loud/credit/creditWxYqReport.vue'),
        meta: {
            title: '应收逾期账龄报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/creditNxFhFpReport',
        component: () => import( '@/views/loud/credit/creditNxFhFpReport.vue'),
        meta: {
            title: '应收逾期账龄报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    //内销
    {
        path: '/creditNxYqReport',
        component: () => import( '@/views/loud/credit/creditNxYqReport.vue'),
        meta: {
            title: '应收逾期账龄报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/creditWxYqDayReport',
        component: () => import( '@/views/loud/credit/creditWxYqDayReport.vue'),
        meta: {
            title: '海外应收逾期账龄日报表',
            isTabsPage: true,
            keepAlive: true
        }
    },
    //内销
    {
        path: '/creditNxYqDayReport',
        component: () => import( '@/views/loud/credit/creditNxYqDayReport.vue'),
        meta: {
            title: '国内应收逾期账龄日报表',
            isTabsPage: true,
            keepAlive: true
        }
    },

    // 客户详情
    {
        path: '/credit/contrasSapShenPi',
        component: () => import( '@/views/loud/credit/contrastSapSp.vue' ),
    },
]
